import { useEffect } from 'react';
import { FloatingFormItem } from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Checkbox, Col, Form, Input, Row } from 'antd';
import { useGetNumberingId } from '@/core/domain/invoice/Numberings/Numberings.hook';
import { NumberingsForm } from '@/core/domain/invoice/Numberings/Numberings.types';
import { FormInstance } from 'antd/es/form/Form';

interface Props {
  isEdit?: number;
  configNfs?: number;
  form: FormInstance<NumberingsForm>;
}

const SerieNumberModalForm = ({ isEdit, form, configNfs }: Props) => {
  const ruleRequired = useDefaultEmptyFieldError();
  const main = Form.useWatch('main');

  const { mutateAsync, data } = useGetNumberingId();

  useEffect(() => {
    if (isEdit) {
      mutateAsync(isEdit);
    }
  }, [isEdit]);

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <FloatingFormItem name="series" label="Série" rules={[ruleRequired]}>
          <Input />
        </FloatingFormItem>
      </Col>

      <Col span={24}>
        <FloatingFormItem
          name="initialNumber"
          label={configNfs ? 'Numeração inicial RPS' : 'Numeração inicial'}
          rules={[ruleRequired]}
        >
          <Input />
        </FloatingFormItem>
      </Col>

      <Col span={24}>
        <FloatingFormItem valuePropName="checked" name="main">
          <Checkbox disabled={isEdit && main}>Principal?</Checkbox>
        </FloatingFormItem>
      </Col>
    </Row>
  );
};

export default SerieNumberModalForm;
